import { render, staticRenderFns } from "./column5.vue?vue&type=template&id=866f1b84&"
import script from "./column5.vue?vue&type=script&lang=js&"
export * from "./column5.vue?vue&type=script&lang=js&"
import style0 from "./column5.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "column5.vue"
export default component.exports